import React from 'react'
import styled from 'styled-components'
import styles from './styles/styles.module.scss'

/**
 * Fixed container
 * @param {node} children
 * @param {string} top
 * @param {number} zIndex
 * @param id
 * @returns {JSX.Element}
 * @constructor
 */
function FixedContainer({ children, top = '0', zIndex = 10, id = null, className }) {
  return (
    <>
      <Container $top={top} $zIndex={zIndex} id={id} className={className}>
        {children}
      </Container>
      {/* Just a space, because the minimal header is sticky, so it takes no space */}
      <div className={styles.MinimalHeaderGapDiv} />
    </>
  )
}

const Container = styled.div<any>`
  position: fixed;
  width: 100%;
  top: ${({ $top }) => $top};
  z-index: ${({ $zIndex }) => $zIndex};
`

export default FixedContainer
